import { Component } from 'react';
import { connect } from 'react-redux';
import Head from 'next/head';
import Notification from '@/components/Base/Notification';
import { FullPage } from './FullPage';
import { withErrorBoundary } from '@/utils/errors';

class WebpageAEG extends Component {
  render() {
    const { webpageUsername, isCompanyWebpage } = this.props;

    // company fields
    let tracking_code;

    // user fields
    let email, faqs, latest_news;
    let about_me, personal_photo, first_name, last_name;
    let cell_phone, phone, phone_ext, agent_licenses, title;
    let address_1, address_2, city, state, zip_code;
    let facebook, twitter, instagram, linkedin, google, youtube, yelp;
    let office_hours, languages_spoken;

    if (isCompanyWebpage) {
      ({
        name: first_name,
        description: about_me,
        office_email: email,
        office_phone: phone,
        office_address: address_1,
        office_city: city,
        office_state: state,
        office_zip_code: zip_code,
        logo: personal_photo,
        faqs,
        latest_news,
        facebook,
        twitter,
        instagram,
        linkedin,
        google,
        youtube,
        yelp,
        office_hours,
        languages_spoken,
        tracking_code
      } = this.props.info);
    } else {
      ({
        email,
        corporation: { faqs, latest_news },
        profile: {
          about_me,
          personal_photo,
          first_name,
          last_name,
          cell_phone,
          phone,
          phone_ext,
          agent_licenses,
          title,
          address_1,
          address_2,
          city,
          state,
          zip_code,
          facebook,
          twitter,
          instagram,
          linkedin,
          google,
          youtube,
          yelp,
          office_hours,
          languages_spoken
        }
      } = this.props.info);
    }

    const profileInfo = {
      webpageUsername,
      isCompanyWebpage,
      email,
      about_me,
      personal_photo,
      first_name,
      last_name,
      cell_phone,
      phone,
      phone_ext,
      agent_licenses,
      address_1,
      address_2,
      city,
      state,
      zip_code,
      title,
      facebook,
      twitter,
      instagram,
      linkedin,
      google,
      youtube,
      yelp,
      office_hours,
      languages_spoken,
      faqs,
      latest_news
    };

    return (
      <>
        <Head>
          <title>{`${[first_name, last_name].join(' ')} | American Republic Insurance Services®`}</title>
          {isCompanyWebpage && tracking_code?.length && <script dangerouslySetInnerHTML={{ __html: tracking_code }} />}
        </Head>
        <FullPage profileInfo={profileInfo} />
        <div style={{ fontSize: '1.4rem', width: '100%' }}>
          <Notification />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  info: state.public.info,
  additional_info: state.public
});

export default connect(mapStateToProps)(withErrorBoundary(WebpageAEG));
